module.exports = __webpack_public_path__ + "img/three-yellow-light.2265132c.svg";